import { useState, useEffect, useRef } from 'react';

/**
 * Хук возвращающий кэшированное значение с указанной задержкой.
 * @param value Значение
 * @param delay Задержка в мс ( по умолчанию - 300мс)
 * @returns Кэшированное значение
 */
const useDebounce = <T>(
	callback: (debValue: T) => void,
	initValue: T,
	delay = 300,
) => {
	const timerRef = useRef<NodeJS.Timeout>();
	const [value, setValue] = useState<T>(initValue);

	useEffect(() => {
		let timer = timerRef.current;
		if (!timer) {
			timer = setTimeout(() => {
				callback(value);
				timer = undefined;
			}, delay);
		}
		return () => {
			if (timer) {
				clearTimeout(timer);
			}
		};
		// eslint-disable-next-line
	}, [value]);

	return [value, setValue] as const;
};

export default useDebounce;
